// extracted by mini-css-extract-plugin
export default {"wrap":"notFoundResults_wrap__G+lmd","title":"notFoundResults_title__dRw8l","subTitle":"notFoundResults_subTitle__Gv+1l"};